module.exports = __webpack_public_path__ + "img/peptidbindung.a58af6d4.png";